import Sources from './Sources.container';

export default Sources;
